
import api from './api'

import { useCache } from '@/helpers/cache'
import { useDownload } from '@/helpers/download'

export default {

    count(params = {}) {
        
        return api.get('/me/favorites', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },
    
    deleteFavorite(articleVariationPostId) {

        return api.delete('/me/favorites/' + articleVariationPostId, {})
            .then(() => {
                useCache().clear('/catalog')
                useCache().clear('/me/favorites')
            })            
    },

    get() {

        return api.get('/me', {})
            .then( json => json.data )
            
    },

    getAddresses() {

        return api.get('/me/addresses', {})
            .then( json => json.data )
            
    },

    getFavorites(cache = false) {

        return api.get('/me/favorites', { cache: cache })
            .then( json => json.data )            
    },   
        
    
    getFavoritesXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/me/favorites/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },

    getFavoritesTable(cache = false) {

        return api.get('/me/favorites/table', { cache: cache })
            .then( json => json.data )            
    },

    getHabilitations() {

        return api.get('/me/habilitations', {})
            .then( json => json.data )
            
    },

    list(params = {}) {

        return api.get('/me/favorites', { params, cache: false })
            .then( json => json.data )              
    },
    
    putFavorite(articleVariationPostId) {

        return api.put('/me/favorites/' + articleVariationPostId, {})
            .then(() => {
                useCache().clear('/catalog')
                useCache().clear('/me/favorites')
            })            
    },

    search(params = {}) {
        return api.get('/me/favorites', { params })
            .then( json => json.data )            
    }     
}
